import React, { Fragment } from "react"
import { compose } from "redux"
import { GUTTER_MD, SPAN_FULL } from "../../../../../styles/constants"
import { Checkbox, Col, Form, Input, Row } from "antd"
import { formItemLayout } from "../ConnectionControl"
import { translate } from "react-i18next"
import { isPortValid } from "../validateUtils"

const FormDbTypeMSSQL = ({
        t,
        form,
}) => {

    return (
        <Fragment>
            <Row gutter={GUTTER_MD}>
                <Col span={SPAN_FULL}>
                     <Form.Item
                        className="form-item-required"
                        label="Server:"
                        {...formItemLayout}
                        >
                        {form.getFieldDecorator('server')(
                            <Input  /> 
                        )}
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={GUTTER_MD}>
                <Col span={SPAN_FULL}>
                    <Form.Item
                        className="form-item-required"
                        label="Database:"
                        {...formItemLayout}
                        >
                        {form.getFieldDecorator('database')(
                            <Input /> 
                        )}
                    </Form.Item> 
                </Col>
            </Row>
            <Row gutter={GUTTER_MD}>
                <Col span={SPAN_FULL}>
                    <Form.Item
                        label={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.msSql.port')}
                        type='number'
                        {...formItemLayout}
                        validateStatus={form.getFieldValue('port') && isPortValid(t, form.getFieldValue('port')).help ? "warning" : null}
                        help={form.getFieldValue('port') && isPortValid(t, form.getFieldValue('port')).help}    
                    >
                        {form.getFieldDecorator('port')(
                            <Input 
                                type="number"
                            />                  
                        )}
                    </Form.Item>  
                </Col>
            </Row>
            <Row gutter={GUTTER_MD}>
                <Col span={SPAN_FULL}>
                    <Form.Item
                        className="form-item-required"
                        label="User ID:"
                        {...formItemLayout}
                        >
                        {form.getFieldDecorator('userId')(
                            <Input
                                disabled={!!form.getFieldValue('integratedSecurity')} /> 
                        )}
                    </Form.Item>  
                </Col>
            </Row>
            <Row gutter={GUTTER_MD}>
                <Col span={SPAN_FULL}>
                    <Form.Item
                        className="form-item-required"
                        label="Password:"
                        {...formItemLayout}
                        >
                    {form.getFieldDecorator('password')(
                        <Input
                            disabled={!!form.getFieldValue('integratedSecurity')}
                            type="password"
                        />   
                    )}
                    </Form.Item>  
                </Col>
            </Row>
            <Row gutter={GUTTER_MD}>
                <Col span={SPAN_FULL}>
                    <Form.Item
                        label={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.msSql.integratedSecurity')}
                        {...formItemLayout}
                    >
                     {form.getFieldDecorator('integratedSecurity',{valuePropName: 'checked'})(   
                        <Checkbox
                            label={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.msSql.integratedSecurity')}
                    /> )}  
                    </Form.Item>
                </Col>
            </Row>
        </Fragment>
    )
}


export default compose(
    translate()
)(FormDbTypeMSSQL)